import styled from '@emotion/styled';
import BubbleMessage from './BubbleMessage';

export interface SystemMessageProps {}

const SystemMessageBox = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto 15px;
  text-align: center;
`;
const Bubble = styled(BubbleMessage)`
  padding: 8px 10px;
  color: var(--fett-text-tertiary);
  background: var(--fett-chat-bubble-system);
  font-size: 12px;
  border: 1px solid var(--fett-border-default);
`;

const SystemMessage: React.FC<SystemMessageProps> = ({ children }) => {
  if (!children) return null;
  return (
    <SystemMessageBox>
      <Bubble color="var(--fett-chat-bubble-system)">{children}</Bubble>
    </SystemMessageBox>
  );
};
export default SystemMessage;
